// this file is automatically generated by git.version.ts script
export const versions = {
  version: '7.11.5',
  revision: 'NO_REV',
  branch: 'NO_BRANCH',
};
